import axios from 'axios'
import jsonWebToken from 'Services/jsonWebToken'
import { apiUrl } from 'Services/accessUrl'
import { ApiResult, ApiCreditCard, ApiCreditCardAddResult } from 'Types'

const endpoint = `${apiUrl.stable}/cartao`

/** Returns a list of cards from the signed user's account */
export const getCardList = ():ApiResult<ApiCreditCard[]> => {
  const url = `${endpoint}/obtem`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.get(url, { headers })
}

/**
 * Add a new credit card to the signed user's acount
 * @param {ApiCreditCardAdd} data
 */
export const addCard = (data): ApiResult<ApiCreditCardAddResult> => {
  const url = `${endpoint}/cadastra`

  const headers = {
    ...jsonWebToken.header
  }

  return axios.post(url, data, { headers })
}

/**
 * Delete a credit card of the signed user's acount
 * @param {number} cardId - The credit card database id
 */
export const deleteCard = (cardId) => {
  const url = `${endpoint}/remove`

  const headers = {
    ...jsonWebToken.header
  }

  const params = {
    Id: cardId
  }

  return axios.delete(url, { headers, params })
}

export const updateMainCard = (cardId: number) => {

}

export default {
  getCardList,
  addCard,
  deleteCard,
  updateMainCard,
}